// libs
import * as React from 'react'

// classes / components
import Notification, { clsHighlightedText, clsText, NotificationProps } from 'src/components/notifications/notification'
import { textResources } from 'src/lang/de'

// helpers
import DateFormatter from 'src/utils/date_formatter/date_formatter'

const labels = textResources.notification

export type ProjectContentNotificationProps = {
  createdAt: string;
  projectName: string;
  contentItemTitle: string | null | undefined;
} & Pick<
  NotificationProps,
  'avatarImage' | 'initiatorName' | 'isRead' | 'onClick'
>;

const ProjectContentNotification: React.FC<ProjectContentNotificationProps> = ({
  avatarImage,
  createdAt,
  initiatorName,
  isRead,
  onClick,
  projectName,
  contentItemTitle
}) => {
  return (
    <Notification
      avatarImage={avatarImage}
      footer={DateFormatter.asTimeAgo(createdAt)}
      initiatorName={initiatorName}
      isRead={isRead}
      onClick={onClick}
    >
      <span className={clsText}>{` ${labels.notificationNewProjectContent}`}</span>
      {projectName && (
        <strong className={clsHighlightedText}>{`„${projectName}“`}</strong>
      )}
      <span className={clsText}>{labels.notificationGroupPostEnd}</span>
      {contentItemTitle && <strong className={clsHighlightedText}>{`„${contentItemTitle}“`}</strong>}
    </Notification>
  )
}

export default ProjectContentNotification
